import React from 'react';
import { Grid, Box } from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment'
import {isEmpty} from 'lodash'

const UseStyleProgress = makeStyles((theme) => ({
  root: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  bottom: {
    color: '#E6E6E6',
  },
  top: {
    color: 'transparent',
    animationDuration: '550ms',
    position: 'absolute',
  },
  circle1: {
    strokeLinecap: 'round',
    stroke: "url(#1)",
    // transition: "all ease-out 1s",
    position: 'absolute',
    '-webkit-transition': 'all ease-out 1s',
    '-moz-transition': 'all ease-out 1s',
    '-ms-transition': 'all ease-out 1s',
    '-o-transition': 'all ease-out 1s',
    transition: 'all ease-out 1s',
  },
  circle2: {
    strokeLinecap: 'round',
    stroke: "url(#2)",
    // transition: "all ease-out 1s",
    position: 'absolute',
    '-webkit-transition': 'all ease-out 1s',
    '-moz-transition': 'all ease-out 1s',
    '-ms-transition': 'all ease-out 1s',
    '-o-transition': 'all ease-out 1s',
    transition: 'all ease-out 1s',
  },
  circle3: {
    strokeLinecap: 'round',
    stroke: "url(#3)",
    // transition: "all ease-out 1s",
    position: 'absolute',
    '-webkit-transition': 'all ease-out 1s',
    '-moz-transition': 'all ease-out 1s',
    '-ms-transition': 'all ease-out 1s',
    '-o-transition': 'all ease-out 1s',
    transition: 'all ease-out 1s',
  },
  bgCircle: {
    // position: 'absolute',
    // height: '125px',
    // width: '125px',
    // backgroundColor: '#fff',
    // borderRadius: '50%',
    // boxShadow: 'inset 3px 3px 6px 0px rgba(0,0,0,0.15)'
  }
}));


function ProgressCircle(props) {

  const classes = UseStyleProgress();

  const [rotate, setRotate] = React.useState("rotate(65)")
  const [progress, setProgress] = React.useState(0)
  const [circleValue, setCircleValue] = React.useState(classes.circle1)
  // const [vinstMarg, setVinstmarg] = React.useState(parseInt(props.Vinstmarginal) > 100 ? 100 : parseInt(props.Vinstmarginal));
  const [data, setData] = React.useState(0)




  const getRotate = () => {
    if(data > 0) {
      if(data  <= 20) {
        setRotate("rotate(-15)")
      }
      else if(data  > 20 && data  < 40) {
        setRotate("rotate(0)")
      }
      else if(data  > 40 && data  < 60) {
        setRotate("rotate(25)")
      }
      else if(data  > 60 && data  < 80) {
        setRotate("rotate(60)")
      }
      else if(data  > 80 ) {
        setRotate("rotate(65)")
      }
      else {
        setRotate("rotate(65)")
      }
    }

  }


  React.useEffect(() => {

    if(props.isFrom !== 0) {
      if(props.isFrom === 1) {
        setCircleValue(classes.circle1)
      }
      else if(props.isFrom === 2) {
        setCircleValue(classes.circle2)
      }
      else if(props.isFrom === 3) {
        setCircleValue(classes.circle3)
      }
      else {
        setCircleValue(classes.circle1)
      }
      if(isEmpty(props.Budget)) {

      }
    }
    // setData(parseInt((props.MonthVunnen/props.Budget)*100))
    // getRotate()
    // setProgress(parseInt((props.MonthVunnen/props.Budget)*100) > 100 ? 100 : parseInt((props.MonthVunnen/props.Budget)*100))
    // setTimeout(() => { getRotate() }, 1000);
  }, []); 
  React.useEffect(() => {
    setData(parseInt((props.MonthVunnen/props.Budget)*100))
    setProgress(parseInt((props.MonthVunnen/props.Budget)*100) > 100 ? 100 : parseInt((props.MonthVunnen/props.Budget)*100))
    getRotate()
    console.log('test123456', data)
  })
  // console.log(vinstMarg)
  // console.log(props.size, 'test123456')
  // console.log(props.Budget, 'test123456')
  // console.log(props.MonthVunnen, 'test123456')
  // console.log(props.percentage, 'test123456')
  // console.log(data, 'test123456')
  return (
    <Box>
        <svg width="100%" height="100%" style={{position: 'absolute', pointerEvents: 'none', left: '-100px'}}>
          <linearGradient id={props.isFrom} x1="0" y1="0" x2="1" y2="0" gradientTransform={rotate}>
            <stop offset="0%" stopColor="#C377E0" />
            <stop offset="100%" stopColor="#44D1C2" />
          </linearGradient>
        </svg>
      <Grid
        container
        direction="column"
        
        style={{ borderRadius: '5px', padding: '0.5rem' }}
      >
        
        <Grid item xs={12} style={{justifyContent: 'center', alignItems: 'center', marginTop: '5px'}}>


          <div className={classes.root}>
            <div className={classes.bgCircle}></div>
            <CircularProgress
              variant="determinate"
              className={classes.bottom}
              size={props.size}
              thickness={4}
              {...props}
              value={100}
            />
              {/* <h3 style={{ position: 'absolute', fontWeight: '500', marginBottom: '0px' }}>{props.Vinstmarginal}{props.Currexy}</h3> */}

            <CircularProgress
              variant="determinate"
              disableShrink
              className={classes.top}
              classes={{
                circle: circleValue
              }}
              // classes={{
              //   circle: classes.circle,
              // }}
              size={props.size}
              thickness={4}
              {...props}
              // value={40}
              value={progress}
              // value={parseInt((props.MonthVunnen/props.Budget)*100) > 100 ? 100 : parseInt((props.MonthVunnen/props.Budget)*100)}
              // value={parseInt(props.Vinstmarginal) > 100 ? 100 : parseInt(props.Vinstmarginal)}
            />
          </div>
        </Grid>

        <Grid item xs={12} className="text-center p-0">
              {/* <h4 className="mb-0 mt-3" style={{ fontWeight: '500' }}>{props.Title}</h4> */}
              {/* <p>{props.Aterkomst.toLocaleString()} st</p> */}

              {/* {
                props.period === 0?
                moment(new Date()).format("YYYY"):
                `20${props.period[0]}${props.period[1]}`
              } */}
        </Grid>



      </Grid>
    </Box>
  );
}

export default ProgressCircle;